var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('nprogress-container'),_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor,"logo":_vm.logo,"title":_vm.title}},[_c('user-menu'),_c('mobile-menu'),_c('template',{slot:"links"},[(_vm.showMenu('crm.route.dashboard'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'dashboard',
          path: { name: 'Dashboard' }
        }}}):_vm._e(),(_vm.showMenu('crm.route.customer'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Customers',
          icon: 'group',
          path: { name: 'Customer Management' }
        }}}):_vm._e(),(_vm.showMenu('crm.route.enquiries'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Enquiries',
          icon: 'textsms',
          path: { name: 'Enquiry Management' }
        }}}):_vm._e(),(_vm.showMenu('crm.route.booking'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Bookings',
          icon: 'event_available',
          path: { name: 'Booking Management' }
        }}}):_vm._e(),(_vm.showMenu('crm.route.tour'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Adventures',
          icon: 'public',
          path: { name: 'Adventure Management' }
        }}}):_vm._e(),(_vm.showMenu('crm.route.reports'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Reports',
          icon: 'content_paste',
          path: { name: 'Reporting' }
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }